import { __decorate } from "tslib";
import { Mixins, Component, Watch, Prop } from 'vue-property-decorator';
import _, { startCase } from 'lodash';
import RouterPathMixin from '@/helpers/mixins/RouterPathMixin';
import { STORE_MANAGEMENT, B2B } from '@/helpers/constants/CustomBundleKeys';
import { OVERVIEW_ROUTE } from '@/helpers/constants/StoreManagerRoutes';
import { Mutation } from 'vuex-class';
import { NAV_DRAWER } from '@/helpers/constants/app';
let TheBreadcrumb = class TheBreadcrumb extends Mixins(RouterPathMixin) {
    constructor() {
        super(...arguments);
        this.visitedLinks = [];
    }
    get dashboardPath() {
        return `/apps/${this.appUUID}/overview/`;
    }
    onUrlChange() {
        this.getBreadcrumb();
    }
    generateDashboardUrl(routeKey) {
        if (routeKey === 'ecommerce-b2c-bundle' || routeKey === 'shopify-bundle') {
            return 'ecommerce-overview';
        }
        if (routeKey === 'survey-and-raffle-bundle') {
            return 'survey-overview';
        }
        if (routeKey === 'inquiry-bundle') {
            return 'inquiry-overview';
        }
        if (routeKey === 'insurance-bundle') {
            return 'insurance-overview';
        }
        if (routeKey === STORE_MANAGEMENT) {
            return OVERVIEW_ROUTE.name;
        }
        if (routeKey === B2B) {
            return 'b2b-overview';
        }
        if (this.isNetworkDistributorPage()) {
            return 'reseller-mini-apps-overview';
        }
        if (this.isSalesPartnerPage()) {
            return 'affiliate-invites';
        }
        if (routeKey === 'affiliate-bundle') {
            return 'affiliate-overview';
        }
        return 'not-found';
    }
    generateRedirectUrl(name, isReferral) {
        if (isReferral) {
            return 'ecommerce-referral';
        }
        return name;
    }
    getBreadcrumb() {
        const { params } = this.$route;
        const links = [
            {
                name: this.generateDashboardUrl(params.key),
                meta: { title: `${this.isSalesPartnerPage() ? 'Sales Partner Manager' : 'Dashboard'}` },
                params,
                id: '-Dashboard',
            },
        ];
        /**
         * Filter Matched Route With Name and Redirect property
         *  - name -> Actual Visited Route
         *  - redirect - > Parent Route identifier in case route is nested menu
         * PS:title meta is required to display Route title in Breadcrumb
         */
        const matched = this.$route.matched.filter((item) => {
            return ((!!item.name &&
                item.name !== 'overview' &&
                item.name !== 'affiliate-manager' &&
                item.name !== 'network-distributor-dashboard') ||
                !!item.meta.redirect);
        });
        const getReferralLink = !!params.referralLinkUuid;
        matched.forEach((match) => {
            this.showInbox(false);
            const { name, meta } = match;
            links.push({
                name: this.generateRedirectUrl(name || meta.redirect, getReferralLink),
                meta,
                params,
                id: `${name}-${meta.title}`,
            });
        });
        const getStatus = !!params.status;
        if (getStatus) {
            const { name, meta } = this.$route;
            links.push({
                name: name || meta.redirect,
                meta: { title: startCase(params.status) },
                params: { status: params.status },
                id: `${name}-${meta.title}`,
            });
        }
        if (getReferralLink) {
            const { name, meta } = this.$route;
            links.push({
                name: name || meta.redirect,
                meta: { title: 'Details' },
                params: { referralLinkUuid: params.referralLinkUuid },
                id: `${name}-${meta.title}`,
            });
        }
        // Filter Links By Object Name https://lodash.com/docs/4.17.11#uniqBy
        // Change filtering from id to meta.title to avoid breadcrumbs redundancy
        this.visitedLinks = _.uniqBy(links, 'meta.title');
        const getMerchantUuid = !!params.merchantUuid;
        if (getMerchantUuid) {
            const index = this.visitedLinks.findIndex((item) => {
                return item.name === 'reseller-merchants-by-status';
            });
            const obj = this.visitedLinks[index].params;
            if (obj) {
                obj.status = 'activated';
            }
        }
    }
    created() {
        this.getBreadcrumb();
    }
};
__decorate([
    Prop()
], TheBreadcrumb.prototype, "appUUID", void 0);
__decorate([
    Prop()
], TheBreadcrumb.prototype, "baseAppUUID", void 0);
__decorate([
    Mutation('showInbox', { namespace: NAV_DRAWER })
], TheBreadcrumb.prototype, "showInbox", void 0);
__decorate([
    Watch('$route')
], TheBreadcrumb.prototype, "onUrlChange", null);
TheBreadcrumb = __decorate([
    Component
], TheBreadcrumb);
export default TheBreadcrumb;
